import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import LanguageCard from '@/components/LanguageCard';
import AdSlot from '@/components/AdSlot';
import EvolvingRibbon from '@/components/EvolvingRibbon';
import PeerHint from '@/components/PeerHint';
import useSEO from '@/hooks/useSEO';

export default function Languages() {
    useSEO({
        title: 'All languages — Linguistic Quest puzzle library',
        description: 'Browse every language on Linguistic Quest: Shona, Ndebele, Yoruba, Swahili, French and Portuguese live now, with Spanish, Zulu, Xhosa, Amharic, Hausa, Igbo, Chichewa and Afrikaans on the way.',
        path: '/languages',
    });
    const [languages, setLanguages] = useState([]);
    useEffect(() => { api.get('/languages').then(({ data }) => setLanguages(data.languages || [])); }, []);
    const live = languages.filter((l) => l.status === 'live');
    const coming = languages.filter((l) => l.status === 'coming_soon');
    return (
        <main className="max-w-7xl mx-auto px-6 py-16" data-testid="page-languages">
            <p className="text-sm font-semibold uppercase tracking-wider text-lq-purple-500">Languages</p>
            <h1 className="mt-2 font-display text-4xl md:text-5xl font-semibold text-lq-ink-black">Puzzle your way to a new language.</h1>
            <p className="mt-4 max-w-2xl text-lq-ink-700">Choose your launch language. Every paid tier gives access to all four age tiers — Seedlings (4–7), Growers (8–11), Explorers (12–15), Teens (16+).</p>
            <div className="mt-4"><EvolvingRibbon /></div>
            <div className="mt-6"><PeerHint /></div>
            <div className="mt-8">
                <AdSlot slug="languages-top" />
            </div>
            <section className="mt-10">
                <h2 className="font-display text-2xl font-semibold mb-5 text-lq-ink-900">Live now</h2>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="live-languages-grid">
                    {live.map((l) => <LanguageCard key={l.id} language={l} wordCount={l.word_count} />)}
                </div>
            </section>
            <section className="mt-14">
                <h2 className="font-display text-2xl font-semibold mb-5 text-lq-ink-900">Coming soon</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="coming-languages-grid">
                    {coming.map((l) => <LanguageCard key={l.id} language={l} />)}
                </div>
            </section>
        </main>
    );
}
